<script lang="ts">
    import {Flex} from 'shared/layouts';
    import KpPopover from '../popover/KpPopover.svelte';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
</script>

<KpPopover placement="top-start">
    <svelte:fragment slot="whole-button" let:buttonId let:panelId let:floatingRef>
        <KpIconButton icon="question"
                      id={buttonId}
                      popovertarget={panelId}
                      use={[floatingRef]}/>
    </svelte:fragment>

    <svelte:fragment slot="popover-title">
        <span class="heading-title">Nápověda k formátování</span>
    </svelte:fragment>

    <Flex slot="popover-content" direction="column" gap="m" class="message-formatting-help">
        <!-- Text formatting -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Formátování textu</span>

            <span class="help-item-description">
                <em>Kurzíva</em>: <code>*text*</code> nebo <code>_text_</code><br/>
                <strong>Tučně</strong>: <code>**text**</code> nebo <code>__text__</code><br/>
                <del>Přeškrtnuté</del>: <code>~~text~~</code><br/>
                <strong><em>Kombinace tučné + kurzíva</em></strong>: <code>***text***</code><br/>
                <code class="markdown-code">Inline kód</code>: <code>`text`</code>
            </span>
        </Flex>

        <!-- Headings -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Nadpisy</span>

            <span class="help-item-description">
                <strong>Nadpis 1</strong>: <code># Text</code><br/>
                <strong>Nadpis 2</strong>: <code>## Text</code><br/>
                <strong>Nadpis 3</strong>: <code>### Text</code><br/>
                <strong>Nadpis 4</strong>: <code>#### Text</code><br/>
                <strong>Nadpis 5</strong>: <code>##### Text</code>
            </span>
        </Flex>

        <!-- Lists -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Seznamy</span>

            <span class="help-item-description">
                <strong>Nečíslovaný seznam</strong>: <code>- položka</code> nebo <code>* položka</code><br/>
                <strong>Číslovaný seznam</strong>: <code>1. položka</code><br/>
                <strong>Vnořené položky</strong>: odsadit pomocí tabulátoru
            </span>
        </Flex>

        <!-- Links & Images -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Odkazy & obrázky</span>

            <span class="help-item-description">
                <strong>Odkaz</strong>: <code>[text](https://example.com)</code><br/>
                <strong>Obrázek</strong>: <code>![popis](https://example.com/image.png)</code>
            </span>
        </Flex>

        <!-- Quote -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Citace</span>

            <span class="help-item-description">
                <strong>Citace</strong>: <code>&gt; text</code>
            </span>
        </Flex>

        <!-- Code block -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Blok kódu</span>

            <span class="help-item-description">
                <strong>Kódový blok</strong>:<br/>
                <code>```</code><br/>
                <code>kód</code><br/>
                <code>```</code>
            </span>
        </Flex>

        <!-- Horizontal rule -->
        <Flex direction="column" as="section" gap="s" class="help-item">
            <span class="help-item-title">Oddělovač</span>

            <span class="help-item-description">
            <strong>Horizontální čára</strong>: <code>---</code> nebo <code>***</code>
        </span>
        </Flex>
    </Flex>
</KpPopover>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .heading-title,
    .help-item-title {
        font-weight: 500;
    }

    .markdown-code {
        background-color: @themed-panel-bg;
        border-radius: @border-radius-sm;
        color: @themed-text-default;
        padding: 1px 3px;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 0.9em;
    }

    code {
        color: var(--brand-orange);
        background-color: @themed-body-bg-orange-highlighted;
        border-radius: @border-radius-sm;
        padding: 3px 5px;
    }
</style>